import * as React from 'react';
import { fm } from 'Components/FormatMessage';
import { isPartialDate } from 'neuro-utils';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { mgadl, mgc } from 'neuro-schemas';
import { formatPartialDate } from 'Utility/date';
import { filterByDocumentType, sortDocumentsDescending } from 'Utility/documentHandling';
import type { TFunctionalPerformanceMgravisDocumentType } from '../utils';

const { calculateScore: calculateMGCScore } = mgc;
const { calculateScore: calculateMGADLScore } = mgadl;

const getLatest = (
  type: SafeExtract<TDocumentType, 'mgc' | 'mgadl'>,
  docs: Array<IDocumentWithTypeV2<TFunctionalPerformanceMgravisDocumentType>>,
): { date: PartialDate | undefined | null; value: React.JSX.Element | string | undefined | number } | undefined => {
  const latestDoc = filterByDocumentType(docs, type)
    .sort((n1, n2) => sortDocumentsDescending(n1 as IDocumentV2, n2 as IDocumentV2))
    .at(0);
  if (!latestDoc) return undefined;
  switch (type) {
    case 'mgc': {
      const latest = latestDoc as IDocumentWithTypeV2<typeof type>;
      const dateOfLatest = latest.date;
      const valueOfLatest = calculateMGCScore(latest) ?? '-';
      return {
        date: dateOfLatest,
        value: valueOfLatest,
      };
    }
    case 'mgadl': {
      const latest = latestDoc as IDocumentWithTypeV2<typeof type>;
      return {
        date: latest.date,
        value: calculateMGADLScore(latest) ?? '-',
      };
    }
  }
};

const FunctionalPerformanceMgravisDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const mgc = getLatest('mgc', documents);
  const mgadl = getLatest('mgadl', documents);

  return (
    <React.Fragment>
      <TileContentMaker
        type="specificList"
        data={[
          {
            date: isPartialDate(mgc?.date) ? formatPartialDate(mgc.date) : '',
            title: fm('functionalPerformanceMgravis.mgcShort'),
            value: !mgc ? fm('functionalPerformanceMgravis.notEvaluated') : mgc.value,
            key: 'mgc',
          },
          {
            date: isPartialDate(mgadl?.date) ? formatPartialDate(mgadl.date) : '',
            title: fm('functionalPerformanceMgravis.mgadlShort'),
            value: !mgadl ? fm('functionalPerformanceMgravis.notEvaluated') : mgadl.value,
            key: 'mg-adl',
          },
        ]}
      />
    </React.Fragment>
  );
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<TFunctionalPerformanceMgravisDocumentType>>;
}

export default FunctionalPerformanceMgravisDash;
